module.exports = __webpack_public_path__ + "static/marketing_expert_bk_flash-8746297e0e667e6cc048ae05cfb67912.png";